import { gql } from "apollo-boost"

export const BLOCK_BENEFICIARIES_F21 = gql`
  mutation BlockParticipants(
    $data: [SaveDataBeneficiary!]!
  ) {
    BlockParticipants (
      data: $data
    ) {
      id
      ultimateEfficiency
      ultimateEfficiencyJustification
      isBlockingParticipants
    }
  }
`